'use strict';

import Raven from 'raven-js';
import ApiKeys from '../constants/ApiKeys';

const ravenEnabled = false;

function setup() {
  Raven.config(ApiKeys.SENTRY_URL);

  if (process.env.NODE_ENV === 'production' && ravenEnabled) {
    Raven.install();
  }
}

function associateWithUser(me) {
  Raven.setUserContext({
    email: me.email,
    id: me.id,
    name: me.name
  });
}

function wrap(f) {
  if (process.env.NODE_ENV === 'production' && ravenEnabled) {
    return Raven.wrap(f);
  } else {
    return f;
  }
}

export default {
  associateWithUser,
  setup,
  wrap
};



/** WEBPACK FOOTER **
 ** ./utils/CrashReporter.js
 **/